<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">Getting the Most Out of <i>David</i></a></div>
<div class="table" id="tableau-001">
<div class="table-align">
<table style="border-collapse:collapse; border-spacing:0px;">
<colgroup style="padding:6px;">
<col style="width:5%;padding:6px;"/>
<col style="width:40%;padding:6px;"/>
<col style="width:55%;padding:6px;"/>
</colgroup>
<tbody>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap1" title="Link target outside of Sample"><span class="mev2">1</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap1" title="Link target outside of Sample"><b>The Lord Looks at the Heart</b></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap1" title="Link target outside of Sample">1 Samuel 16:1-13</span></p></td>
</tr>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap2" title="Link target outside of Sample"><span class="mev2">2</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample"><b>The Battle Is the Lord’s</b></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample">1 Samuel 17</span></p></td>
</tr>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap3" title="Link target outside of Sample"><span class="mev2">3</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample"><b>True Friendship</b></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample">1 Samuel 20:1-17, 30-42</span></p></td>
</tr>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap4" title="Link target outside of Sample"><span class="mev2">4</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample"><b>A Matter of Conscience</b></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample">1 Samuel 24</span></p></td>
</tr>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap5" title="Link target outside of Sample"><span class="mev2">5</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample"><b>Secure in the Lord</b></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample">1 Samuel 25</span></p></td>
</tr>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap6" title="Link target outside of Sample"><span class="mev2">6</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample"><b>Finding Strength in the Lord</b></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample">1 Samuel 30:1-25</span></p></td>
</tr>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap7" title="Link target outside of Sample"><span class="mev2">7</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample"><b>God’s Wrath &amp; Blessing</b></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample">2 Samuel 6</span></p></td>
</tr>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap8" title="Link target outside of Sample"><span class="mev2">8</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap8" title="Link target outside of Sample"><b>God’s Promise to David</b></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap8" title="Link target outside of Sample">2 Samuel 7</span></p></td>
</tr>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap9" title="Link target outside of Sample"><span class="mev2">9</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap9" title="Link target outside of Sample"><b>Facing Temptation</b></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap9" title="Link target outside of Sample">2 Samuel 11</span></p></td>
</tr>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap10" title="Link target outside of Sample"><span class="mev2">10</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap10" title="Link target outside of Sample"><b>God’s Severe Mercy</b></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap10" title="Link target outside of Sample">2 Samuel 12</span></p></td>
</tr>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap11" title="Link target outside of Sample"><span class="mev2">11</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap11" title="Link target outside of Sample"><b>Misplaced Trust</b></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap11" title="Link target outside of Sample">1 Chronicles 21:1—22:1</span></p></td>
</tr>
<tr style="padding:6px;">
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap_autre"><span href="#/chap12" title="Link target outside of Sample"><span class="mev2">12</span></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap12" title="Link target outside of Sample"><b>Generous Giving</b></span></p></td>
<td style="padding:6px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap12" title="Link target outside of Sample">1 Chronicles 29</span></p></td>
</tr>
</tbody></table></div></div>
<div class="SOM_appen"><span href="#/appen3" title="Link target outside of Sample">Leader’s Notes</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?8dde1b72